import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {
      outline: 'none'
    },
    textareaComponents: {
      position: 'relative',
      width: 320,
      boxSizing: 'border-box',
      lineHeight: 0,
      borderRadius: 4,
      border: '1px solid transparent',
      backgroundColor: theme.colors.neutral200,
      transition: 'all 0.15s ease'
    },
    textarea: _objectSpread(_objectSpread({}, theme.typography.body), {}, {
      background: 'transparent',
      color: theme.colors.neutral900,
      minHeight: 38,
      width: '100% !important',
      maxWidth: '100%',
      boxSizing: 'border-box',
      outline: 'none',
      border: 'none',
      padding: '8px 48px 8px 12px',
      margin: 0,
      caretColor: theme.colors.orange500,
      scrollbarWidth: 'thin',
      scrollbarColor: "".concat(theme.colors.neutral700, " ").concat(theme.colors.neutralBase),
      '&::placeholder': {
        color: theme.colors.neutral600
      },
      '&::-webkit-scrollbar': {
        width: 12
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.colors.neutral700,
        border: "3px solid ".concat(theme.colors.neutralBase),
        borderRadius: 6
      }
    }),
    notResizable: {
      resize: 'none'
    },
    error: {
      '& $textareaComponents': {
        backgroundColor: theme.colors.neutralBase,
        border: "1px solid ".concat(theme.colors.red500)
      }
    },
    isReadOnly: {
      '& $textareaComponents': {
        border: "1px solid ".concat(theme.colors.neutral500),
        backgroundColor: theme.colors.neutralBase,
        '&::placeholder': {
          color: theme.colors.neutral500
        }
      },
      '& $textarea': {
        cursor: 'text',
        color: theme.colors.neutral700
      }
    },
    isReadAndDuplicable: {
      '& $postComponentClose': {
        display: 'inline-flex'
      }
    },
    isClickable: {
      cursor: 'pointer'
    },
    clear: {},
    clearSeparator: {
      width: 2,
      height: 8,
      backgroundColor: theme.colors.neutral400,
      margin: '0 2px'
    },
    copy: {},
    focused: {
      '& $textareaComponents': {
        backgroundColor: theme.colors.neutralBase,
        border: "1px solid ".concat(theme.colors.orange500)
      }
    },
    isFullWidth: {
      width: '100%',
      '& $textareaComponents': {
        width: '100%',
        flex: 1
      }
    },
    postComponent: {
      position: 'absolute',
      top: 8,
      right: 12,
      display: 'flex',
      alignItems: 'center',
      '& > span, > div': {
        marginLeft: 4,
        '&:first-child': {
          marginLeft: 0
        }
      }
    },
    postComponentClose: {
      display: 'flex',
      alignItems: 'center'
    },
    postComponentReadOnly: {},
    postComponentCopy: {},
    horizontal: {
      '& [class*="Label"]': {
        alignSelf: 'flex-start',
        paddingTop: 9
      }
    }
  };
});